import React from "react"
import useTeaser from "./useTeaser"
import Item from "@components/content-feed/item"

/**
 * Render a teaser element
 * @param {number} id
 * @param {object|(props:object) => object} customProps
 */
export default (id, override = {}) => {
  let [status, props] = useTeaser(id)
  props =
    typeof override === "function" ? override(props) : { ...props, ...override }

  let element = null
  switch (status) {
    case "loading":
      element = <img src="/img/loading.gif" />
      break
    case "loaded":
      element = <Item {...props} />
      break
    case "error":
      element = <div className="bg-danger bg-error">Inhalt nicht gefunden!</div>
      break
  }
  return [status, element]
}
